import { showError } from 'nuxt/app'
import validators from '~/gql-errors/error-validators'

export default (errorContext, nuxtApp, { disableErrorModal = false } = {}) => {
  const { $bugsnag, $router, $store } = nuxtApp
  const params = $router.currentRoute.value.params

  const { public: config } = useRuntimeConfig()

  const validErrors = errorContext.graphQLErrors?.filter(el => el ?? false) ?? []
  for (const gqlError of validErrors) {
    for (const validator of validators) {
      const result = validator(gqlError, config, params)

      if (!result.valid) { continue }

      if (result.redirect) {
        showError({
          data: result.errorContext,
        })
      }

      // When the modal is disabled suppress only the user-facing modal; the redirect above still runs.
      if (disableErrorModal) { return }

      return $store.commit('error/displayErrorModal', result.errorContext)
    }
  }

  // We haven't caught the error in a validator, log the unknown issue to Bugsnag
  const operationName = errorContext.operation?.operationName ?? 'UNSPECIFIED_OPERATION'

  const errorMessage = `GraphQL Error Handler: Encountered error during operation ${operationName}`

  $bugsnag.notify(new Error(errorMessage), (event) => {
    event.context = `${event.context} | ${operationName}`

    event.addMetadata('GraphQL Context', {
      operation: {
        operationName,
        variables: errorContext.operation?.variables,
        body: errorContext.operation?.query?.loc?.source?.body,
      },
      response: errorContext.response,
    })
  })

  // The unknown error has already been logged to Bugsnag above; when the modal is
  // disabled suppress only the user-facing modal while preserving that logging.
  if (disableErrorModal) { return }

  $store.commit('error/displayErrorModal')
}
